import { LeadsysPictureFilterFormValue } from '../interfaces/leadsys-picture-filter-form-value.interface';

export const mapLeadsysPictureFiltersToUrlParams = (filters: LeadsysPictureFilterFormValue): URLSearchParams => {
  const params = new URLSearchParams();

  Object.keys(filters).forEach((key: string) => {
    const value = filters[key as keyof LeadsysPictureFilterFormValue];
    if (value) {
      if (Array.isArray(value)) {
        value.forEach((item) => {
          params.append(key, item.toString());
        });
      } else if (value instanceof Date) {
        params.append(key, value.toISOString());
      } else {
        // Handle enum values (sortBy, sortOrder) and any other string/number values
        params.append(key, value.toString());
      }
    }
  });

  return params;
};
